<script>
import { defineComponent, h, onMounted, ref } from 'vue';
import Facebook from './channels/Facebook.vue';
import Website from './channels/Website.vue';
import Twitter from './channels/Twitter.vue';
import Api from './channels/Api.vue';
import Email from './channels/Email.vue';
import Sms from './channels/Sms.vue';
import Whatsapp from './channels/Whatsapp.vue';
import WhatsappCall from './channels/WhatsappCall.vue';
import Line from './channels/Line.vue';
import Telegram from './channels/Telegram.vue';
import Instagram from './channels/Instagram.vue';
import Tiktok from './channels/Tiktok.vue';
import MercadoLivre from './channels/MercadoLivre.vue';
import {
  isCanonicalMetaHost,
  redirectToCanonicalMetaHost,
} from 'dashboard/helper/canonicalMetaAuth';

const META_CHANNELS = ['facebook', 'instagram', 'whatsapp'];

const channelViewList = {
  facebook: Facebook,
  website: Website,
  twitter: Twitter,
  api: Api,
  email: Email,
  sms: Sms,
  whatsapp: Whatsapp,
  whatsapp_call: WhatsappCall,
  line: Line,
  telegram: Telegram,
  instagram: Instagram,
  tiktok: Tiktok,
  mercado_livre: MercadoLivre,
};

export default defineComponent({
  name: 'NewChannelView',
  props: {
    channelName: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const isRedirecting = ref(
      META_CHANNELS.includes(props.channelName) && !isCanonicalMetaHost()
    );

    onMounted(async () => {
      if (!isRedirecting.value) return;

      try {
        await redirectToCanonicalMetaHost();
      } catch (_error) {
        isRedirecting.value = false;
      }
    });

    return { isRedirecting };
  },
  render() {
    if (this.isRedirecting) return null;

    const ChannelComponent = channelViewList[this.channelName];
    return ChannelComponent ? h(ChannelComponent) : null;
  },
});
</script>
